module.exports = __webpack_public_path__ + "./images/564da0856a9bdf71a38720ab70c88111.webp";